import { Component, OnInit, OnDestroy } from '@angular/core';
import { PrinterService } from '@shared/services/printer.service';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { printerFeatureKey, PrinterState } from 'src/app/store/printer/printer.reducer';
import { resetPrinterIgnore } from 'src/app/store/printer/printer.actions';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-serial-connections',
  templateUrl: './serial-connections.component.html',
  styleUrls: ['./serial-connections.component.scss'],
  providers: [DialogService]
})
export class SerialConnectionsComponent implements OnInit, OnDestroy {

  public textBtnPrint: string = '';
  public printerIsConnected: boolean = false;
  public printerIsIgnored: boolean = false;
  private connectionSubscription: Subscription | null = null;
  private ignoredSubscription: Subscription | null = null;

  constructor(
    public printerService: PrinterService,
    private store: Store<{ [printerFeatureKey]: PrinterState }>,
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {
    // Suscribirse al estado de conexión
    this.connectionSubscription = this.printerService?.printerIsConnected().subscribe(
      (isConnected) => {
        console.log('SerialConnectionsComponent: Estado de conexión actualizado:', isConnected);
        this.printerIsConnected = isConnected;
        this.updateButtonText();
      }
    );

    // Suscribirse al estado de ignorado
    this.ignoredSubscription = this.store.pipe(select(printerFeatureKey, 'isIgnored')).subscribe(
      (isIgnored) => {
        console.log('SerialConnectionsComponent: Estado de ignorado actualizado:', isIgnored);
        this.printerIsIgnored = isIgnored;
        this.updateButtonText();
      }
    );

    // Verificar si WebUSB está soportado
    if ('usb' in navigator) {
      console.log("WebUSB API is supported.");
    } else {
      console.error("WebUSB API is not supported in this browser.");
    }
  }

  ngOnDestroy(): void {
    // Cancelar suscripción al destruir componente
    if (this.connectionSubscription) {
      this.connectionSubscription.unsubscribe();
    }
    if (this.ignoredSubscription) {
      this.ignoredSubscription.unsubscribe();
    }
  }

  private updateButtonText(): void {
    if (this.printerIsIgnored) {
      this.textBtnPrint = 'Impresora ignorada';
    } else if (this.printerIsConnected) {
      const printerName = localStorage.getItem('printerDevice');
      this.textBtnPrint = `Impresora conectada`;
    } else {
      this.textBtnPrint = 'Conectar impresora';
    }
  }

  async connect(): Promise<void> {
    // Si la impresora está ignorada, restaurar el estado y mostrar el modal
    if (this.printerIsIgnored) {
      console.log('SerialConnectionsComponent: Reseteando estado ignorado');
      this.store.dispatch(resetPrinterIgnore());
      // Ya no es necesario abrir el modal aquí, ya que el estado resetPrinterIgnore lo hará a través del toolbarComponent
      return;
    }

    // Si no está ignorada, comportamiento normal de conexión
    console.log('SerialConnectionsComponent: Solicitando conexión a impresora...');
    try {
      const connected = await this.printerService.requestDevice();
      console.log('SerialConnectionsComponent: Resultado de conexión:', connected);
    } catch (error) {
      console.error('SerialConnectionsComponent: Error al conectar:', error);
    }
  }

  async printTest(): Promise<void> {
    console.log('SerialConnectionsComponent: Intentando imprimir prueba');
    if (!this.printerIsConnected) {
      console.log('SerialConnectionsComponent: Impresora no conectada, intentando conectar primero');
      await this.connect();
    }

    try {
      await this.printerService.printTest();
      console.log('SerialConnectionsComponent: Prueba de impresión completada');
    } catch (error) {
      console.error('SerialConnectionsComponent: Error en prueba de impresión:', error);
    }
  }


}
